// extracted by mini-css-extract-plugin
export var lg = "_43-4";
export var md = "_43-3";
export var sm = "_43-2";
export var xs = "_43-1";
export var xxs = "_43-0";